import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgEurc = function SvgEurc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#2775CA",
        d: "M60 120c33.25 0 60-26.75 60-60S93.25 0 60 0 0 26.75 0 60s26.75 60 60 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M25 47.75c-7.25 19.25 2.75 41 22.25 48 .75.5 1.5 1.5 1.5 2.25v3.5c0 .5 0 .75-.25 1-.25 1-1.25 1.5-2.25 1C32.25 99 21.5 88.25 17 74.25c-7.5-23.75 5.5-49 29.25-56.5.25-.25.75-.25 1-.25 1 .25 1.5 1 1.5 2V23c0 1.25-.5 2-1.5 2.5C37 29.25 28.75 37.25 25 47.75m46.5-29c.25-1 1.25-1.5 2.25-1C87.5 22.25 98.5 33 103 47.25c7.5 23.75-5.5 49-29.25 56.5-.25.25-.75.25-1 .25-1-.25-1.5-1-1.5-2v-3.5c0-1.25.5-2 1.5-2.5C83 92.25 91.25 84.25 95 73.75c7.25-19.25-2.75-41-22.25-48-.75-.5-1.5-1.5-1.5-2.5v-3.5c0-.5 0-.75.25-1",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m75.202 72.198-3.426-1.53a1.54 1.54 0 0 0-2.01.718c-1.616 3.282-4.303 5.373-7.854 5.373-3.213 0-5.791-1.574-7.767-4.754-.772-1.23-1.386-2.604-1.853-4.11h9.2c.582 0 1.116-.328 1.379-.848l2.195-2.963a1.545 1.545 0 0 0-1.38-2.242h-12.43a35 35 0 0 1-.057-1.957c-.007-.663.012-1.314.047-1.954h10.246c.582 0 1.116-.328 1.379-.85l2.195-2.962a1.545 1.545 0 0 0-1.38-2.242H52.282c1.668-5.439 5.15-9.002 9.632-8.932 3.414 0 6.065 1.87 7.765 4.93.381.687 1.239.95 1.957.633l3.443-1.52c.824-.364 1.174-1.36.739-2.148-3.18-5.741-7.814-8.625-13.904-8.625-5.558 0-10.01 2.21-13.392 6.596-1.977 2.583-3.352 5.614-4.169 9.066H39.35c-.583 0-1.117.328-1.38.849l-2.195 2.962a1.545 1.545 0 0 0 1.38 2.242h6.37a41 41 0 0 0-.024 3.912H39.35c-.583 0-1.117.329-1.38.849l-2.195 2.962a1.546 1.546 0 0 0 1.38 2.243h7.183c2.271 9.389 8.811 15.792 17.575 15.66 6.222 0 10.912-3.094 14.042-9.253a1.547 1.547 0 0 0-.754-2.105"
    })));
};

export { SvgEurc as ReactComponent };
//# sourceMappingURL=EURC.svg.es.js.map
